import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLead } from "@/context/LeadContext";
import { IMAGES } from "@/data/content";

export const AiAgents = () => {
  const { openLead } = useLead();

  return (
    <section className="py-24 md:py-32 border-t border-ink/10 overflow-hidden" data-testid="ai-agents-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-8 items-center">
          {/* LEFT — copy */}
          <div className="lg:col-span-7">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.2em] text-coral mb-4">A team that never sleeps</p>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink">
                Add as many virtual AI agents as you need.
              </h2>
              <p className="mt-6 max-w-xl text-base md:text-lg text-ink/70 leading-relaxed">
                Spin up an entire back office of AI specialists &mdash; Concierge, Copywriter,
                Market Analyst, Negotiator, Lead Qualifier &mdash; plus custom agents you build.
                They work for you around the clock,{" "}
                <span className="text-ink font-medium">at no additional cost.</span>
              </p>

              <div className="mt-10 flex items-baseline gap-4">
                <span className="font-serif text-7xl md:text-8xl text-coral leading-none">∞</span>
                <span className="text-sm text-ink/60 max-w-[16ch]">agents included on every paid plan</span>
              </div>

              <button
                onClick={() => openLead({ source: "ai-agents" })}
                data-testid="ai-agents-cta"
                className="group mt-10 inline-flex items-center gap-2 border border-ink/25 text-ink px-7 py-4 text-sm font-medium hover:bg-ink hover:text-bone transition-colors duration-300"
              >
                See the built-in specialists
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>

          {/* RIGHT — phone mockup */}
          <div className="lg:col-span-5 flex justify-center lg:justify-end" style={{ perspective: 1200 }}>
            <Reveal delay={0.1}>
              <motion.div
                initial={{ rotate: 6 }}
                whileHover={{ rotate: 0 }}
                transition={{ type: "spring", stiffness: 200, damping: 20 }}
                className="relative"
              >
                <div className="relative w-[250px] sm:w-[290px] h-[520px] sm:h-[600px] rounded-[44px] bg-ink p-3 shadow-2xl">
                  <div className="absolute top-3 left-1/2 -translate-x-1/2 w-28 h-6 bg-ink rounded-b-2xl z-20" />
                  <div className="w-full h-full rounded-[34px] overflow-hidden bg-bone">
                    <img
                      src={IMAGES.appAgents}
                      alt="Chateaux virtual AI team — built-in real estate specialist agents"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>

                <div className="absolute -left-4 sm:-left-10 top-24 flex items-center gap-2 bg-bone/70 backdrop-blur-xl border border-ink/10 px-3.5 py-2.5 shadow-lg">
                  <span className="w-2 h-2 rounded-full bg-coral" />
                  <span className="text-xs font-medium text-ink whitespace-nowrap">5 built-in + unlimited custom</span>
                </div>
              </motion.div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
